import { render, staticRenderFns } from "./Lawsuits.vue?vue&type=template&id=40a49a98&"
import script from "./Lawsuits.vue?vue&type=script&lang=ts&"
export * from "./Lawsuits.vue?vue&type=script&lang=ts&"
import style0 from "./Lawsuits.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports